export default __webpack_public_path__ + "static/media/icon-back.0e49dcc2.svg";